import { h, Component } from 'preact';
import style from './style';

export default class AnimSequence extends Component {
  constructor (props) {
    super(props);

    this.drawFrame = this.drawFrame.bind(this);
    this.requestFrame = this.requestFrame.bind(this);
    this.play = this.play.bind(this);
    this.restart = this.restart.bind(this);

    this.cache = [];
  }

  requestFrame () {
    if (this.active) {
      // const now = performance.now();
      // let frameDelay;

      // if (this.lastRequestedFrame) {
        // const actualDelay = now - this.lastRequestedFrame;
        // const diffRatio = actualDelay / this.FRAME_DELAY;

        // if (diffRatio > 1) {
        //   frameDelay = this.FRAME_DELAY / diffRatio;
        // }

        // else {
        //   frameDelay = this.FRAME_DELAY * diffRatio;
        // }

        // frameDelay = Math.round(frameDelay);

        

        // console.log('requestFrame', {fps: this.FPS, FD: this.FRAME_DELAY, frameDelay, actualDelay, currentFrame: this.currentFrame});

        setTimeout(() => {
          this.rafRef = window.requestAnimationFrame(this.drawFrame);
        }, this.FRAME_DELAY);
      // }

      // else {
      //   frameDelay = 0;
      //   this.rafRef = window.requestAnimationFrame(this.drawFrame);
      // }

      // this.lastRequestedFrame = now;
      // this.lastFrameDelay = frameDelay;
    }
  }

  requestNextFrame () {
    if (this.active && this.currentFrame !== false) {
      this.advance();
      this.requestFrame();
    }
  }

  play () {
    // console.log('PLAY', this.active, this.currentFrame);
    if (!this.active) {
      return;
    }

    if (this.currentFrame !== this.startFrame) {
      this.currentFrame = this.startFrame;
    }

    if (typeof window !== 'undefined' && typeof window.requestAnimationFrame === 'function') {
      this.requestFrame();
    }
  }

  restart () {
    this.reset({...this.props, active: true});
  }

  stop () {
    if (this.active) {
      this.active = false;
    }

    if (this.rafRef && typeof window !== 'undefined' && typeof window.cancelAnimationFrame === 'function') {
      window.cancelAnimationFrame(this.rafRef);
    }
  }

  pad (n, length) {
    let result = String(n);

    if (!length || typeof length !== 'number') {
      return result;
    }

    while (result.length < length) {
      result = `0${result}`;
    }

    return result;
  }

  preload (props = this.props) {
    if (typeof window !== 'undefined' && props.id && props.src) {
      this.cache = this.getPaths(props)
      .map(path => {
        const img = new Image();
        img.src = path;
        return img;
      });
    }
  }

  getPath (frame) {
    const { id, src } = this.props;
    return getPath({ id, src, frame });
  }

  getPaths ({ id, src, frames, startFrame } = this.props) {
    return getPaths({ id, src, frames, startFrame });
  }

  // pc ( length, position ) {
  //   return ((position / length) * 100).toFixed(2);
  // }

  clearCanvas () {
    const { canvas } = this;

    if (canvas) {
      const width = canvas.width;
      canvas.width = 0;
      canvas.width = width;
    }
  }

  reset (props = this.props) {
    this.active = props.active;
    this.startFrame = props.startFrame || 0;
    this.currentFrame = this.startFrame;
    this.lastRequestedFrame = null;
    this.lastFrameDelay = null;

    if (typeof window !== 'undefined') {
      this.image = new Image();

      this.image.addEventListener('load', () => {
        const canvas = this.canvas;
        const context = canvas.getContext('2d');

        context.clearRect(0, 0, canvas.width, canvas.height);

        if (this.active) {
          context.drawImage(this.image, 0, 0);
        }

        this.requestNextFrame();
      });

      this.image.addEventListener('error', () => {
        console.error('Anim: error loading image', this.props.id, this.image.src);

        this.requestNextFrame();
      });
    }

    // console.log('reset', props.id, this.startFrame);

    if (!props.id || !props.frames) {
      // console.log('anim no id');
      return;
    }

    if (typeof props.play === 'function') {
      props.play(this.play);
    }
    
    if (this.active) {
      this.play();
    }

    else {
      this.clearCanvas();
    }
  }

  drawFrame () {
    if (!this.active) {
      return;
    }

    const { canvas } = this;

    if (canvas) {
      if (this.currentFrame === false) {
        if (this.props.end !== 'last') {
          this.clearCanvas();
        }
        // console.log('drafFrame end', this.props.id, this.currentFrame);
      }

      else {
        const cacheFrame = this.currentFrame - this.startFrame;

        if (cacheFrame in this.cache) {
          const img = this.cache[cacheFrame];

          if (img.complete) {
            const context = canvas.getContext('2d');

            context.clearRect(0, 0, canvas.width, canvas.height);

            // console.log('drawFrame', this.props.id, this.currentFrame, img.src);

            // if (this.active) {
              // console.log('drafFrame cache', this.props.id, this.currentFrame);
              // console.log(this.currentFrame, this.startFrame, this.currentFrame + this.startFrame, this.cache);
              context.drawImage(img, 0, 0);
            // }

            this.requestNextFrame();
          }

          else if (this.image) {
            // console.log('drafFrame cache copy', this.props.id, this.currentFrame);
            this.image.src = img.src;
          }
        }

        else if (this.image) {
          // console.log('drafFrame img', this.props.id, this.currentFrame);
          this.image.src = this.getPath(this.currentFrame);
        }
      }

        // const src = this.getPath(this.currentFrame);
        
        // const img = new Image();
        
        // img.addEventListener('load', () => {
        //   const context = canvas.getContext('2d');

        //   context.clearRect(0, 0, canvas.width, canvas.height);

        //   if (this.active) {
        //     context.drawImage(img, 0, 0);
        //   }

        //   this.requestNextFrame();
        // });

        // img.addEventListener('error', () => {
        //   console.error('Anim: error loading image', this.props.id, src);

        //   this.requestNextFrame();
        // });

        // img.src = src;
      }
  }

  advance () {
    let nextFrame = this.currentFrame + 1;

    if (nextFrame > this.props.frames) {
      if (this.props.loop) {
        let startFrame = 0;

        if (typeof this.props.loop === 'number') {
          startFrame === this.props.loop;
        }

        else if (this.props.startFrame) {
          startFrame = this.props.startFrame;
        }

        const loopEnd = typeof this.props.loop === 'number';
        const frameOffset = startFrame + (loopEnd ? this.props.loop : 0);

        nextFrame = (nextFrame % this.props.frames) + frameOffset - 1;
      }

      else {
        const lastFrame = this.props.frames;

        // console.log({id: this.props.id, lastFrame, currentFrame: this.currentFrame});

        if (this.currentFrame < lastFrame) {
          nextFrame = lastFrame;
        }

        else {
          nextFrame = false;
        }
      }
    }

    this.currentFrame = nextFrame;

    return nextFrame;
  }

  componentWillMount () {
    this.FPS = this.props.fps || 15;
    this.FRAME_DELAY = Math.round(1000 / this.FPS);

    this.reset();
    this.preload();
  }

  componentWillUnmount () {
    this.stop();
    this.clearCanvas();
  }

  shouldComponentUpdate () {
    return false;
  }

  componentWillReceiveProps ( newProps ) {
    if (newProps.fps !== this.props.fps) {
      this.FPS = newProps.fps || 15;
      this.FRAME_DELAY = Math.round(1000 / this.FPS);
    }

    if (
      newProps.id !== this.props.id ||
      newProps.active && !this.props.active ||
      // newProps.play && !this.props.play ||
      newProps.reset !== this.props.reset
    ) {
      // console.log('reset...', newProps, this.props);
      this.reset(newProps);
    }

    else {
      // console.log('not reset', newProps, this.props);
      // this.reset(newProps);
    }

    if (newProps.id !== this.props.id) {
      this.preload(newProps);
    }
  }

  render ({ src, id, frames, loop, play, width, height }, { frame }) {
    // console.log('ANIM', { src, id, frames, loop, play }, this.getPaths());

    return (
      <canvas data-id={ id } ref={ canvas => canvas && (this.canvas = canvas) } class={ style.anim } width={ width } height= { height } />
    );
  }
}

export function pad (n, length) {
  let result = String(n);

  if (!length || typeof length !== 'number') {
    return result;
  }

  while (result.length < length) {
    result = `0${result}`;
  }

  return result;
}

export function getPath ({ id, src, frame }) {
  return `${src}/${id}/${id}_${pad(frame, 5)}.png`;
}

export function getPaths ({ id, src, frames, startFrame = 0 }) {
  const paths = [];

  if (!src || !id || typeof frames !== 'number') {
    console.error('AnimSequence invalid props', { id, src, frames });
    return paths;
  }

  for (let i = startFrame; i <= frames; i++) {
    paths.push(getPath({ id, src, frame: i }));
  }

  return paths;
}



// WEBPACK FOOTER //
// ./components/animsequence/index.js